export default __webpack_public_path__ + "static/media/vector-nav.6cadd2d6.svg";